const whitelabelConfig = {
    lochlomond: {
        brand: 'lochlomond',
        footerPath: './src/components/lochlomond',
        scssVariables: './src/styles/whitelabel-variables/lochlomond',
        navbarLogo: 'lochlomond/logo-full.png',
        title: 'National Park Journey Planner',
        shortTitle: 'Loch Lomond',
        contactEmail: 'support@nationalparkjourneyplanner.co.uk',
        contactEmailHref: 'mailto:support@nationalparkjourneyplanner.co.uk',
        baseUrlIcon: '/llweb.ico',
        docsPolicy: './src/views/pages/lochlomond',
        homePath: './src/views/lochlomond',
        navPath: './src/components/lochlomond',
        support: 'https://support.nationalparkjourneyplanner.co.uk/portal/en/home ',
        androidAppLink: 'https://play.google.com/store/apps/details?id=ltd.ember.lochlomond&gl=GB',
        iOSAppLink: 'https://apps.apple.com/gb/app/national-park-journey-planner/id1567048974',
        showBreadcrumbs: true,
        showUpdatesFooter: true,
        showNeedHelp: true,
        showPois: true,
        enableUserAccounts: true,
        enableMultipleJourneyTypeFilter: false,
        blockedTravelTypes: [],
    },

    goabz: {
        brand: 'goabz',
        footerPath: './src/components/goabz',
        scssVariables: './src/styles/whitelabel-variables/goabz',
        navbarLogo: 'goabz/logo-goabz.png',
        title: 'GoAbz Journey Planner',
        shortTitle: 'GoAbz',
        contactEmail: 'support@goabz.co.uk',
        contactEmailHref: 'mailto:support@goabz.co.uk',
        baseUrlIcon: '/goabz.ico',
        docsPolicy: './src/views/pages/goabz',
        homePath: './src/views/goabz',
        navPath: './src/components/goabz',
        support: 'https://support.goabz.co.uk/portal/en-gb/newticket ',
        androidAppLink: 'https://play.google.com/store/apps/details?id=ltd.ember.goabzprod&gl=GB',
        iOSAppLink: 'https://apps.apple.com/gb/app/goabz/id1504060271',
        showBreadcrumbs: true,
        showUpdatesFooter: true,
        showNeedHelp: true,
        showPois: true,
        enableUserAccounts: true,
        enableMultipleJourneyTypeFilter: false,
        blockedTravelTypes: [],
    },

    dundee: {
        brand: 'dundee',
        footerPath: './src/components/dundee',
        scssVariables: './src/styles/whitelabel-variables/dundee',
        navbarLogo: 'dundee/logo-full.png',
        title: 'My D&A Travel',
        shortTitle: 'My D&A',
        contactEmail: 'support@mydandatravel.com',
        contactEmailHref: 'mailto:support@mydandatravel.com',
        baseUrlIcon: '/dundee.ico',
        docsPolicy: './src/views/pages/dundee',
        homePath: './src/views/dundee',
        navPath: './src/components/dundee',
        support: 'https://support.mydandatravel.com/portal/en/home',
        androidAppLink: 'https://play.google.com/store/apps/details?id=ltd.ember.daprodopen&gl=GB',
        iOSAppLink: 'https://apps.apple.com/gb/app/my-d-a-travel/id1531188896',
        showBreadcrumbs: true,
        showUpdatesFooter: true,
        showNeedHelp: true,
        showPois: true,
        enableUserAccounts: true,
        enableMultipleJourneyTypeFilter: false,
        blockedTravelTypes: [],
    },

    nhs: {
        brand: 'nhs',
        footerPath: './src/components/nhs',
        scssVariables: './src/styles/whitelabel-variables/nhs',
        navbarLogo: 'nhs/logo-full.png',
        title: 'GoNHS Tayside',
        shortTitle: 'GoNHS',
        contactEmail: 'support@goabz.co.uk',
        contactEmailHref: 'mailto:support@goabz.co.uk',
        baseUrlIcon: '/gonhs.ico',
        docsPolicy: './src/views/pages/nhs',
        homePath: './src/views/nhs',
        navPath: './src/components/nhs',
        support: 'https://support.goabz.co.uk/portal/en-gb/newticket ',
        androidAppLink: '',
        iOSAppLink: '',
        showBreadcrumbs: true,
        showUpdatesFooter: true,
        showNeedHelp: true,
        showPois: true,
        enableUserAccounts: false,
        enableMultipleJourneyTypeFilter: false,
        blockedTravelTypes: [],
    },

    sestran: {
        brand: 'sestran',
        footerPath: './src/components/sestran',
        scssVariables: './src/styles/whitelabel-variables/sestran',
        navbarLogo: 'sestran/logo-full.svg',
        title: 'GoSEStran',
        shortTitle: 'GoSES',
        contactEmail: 'support@gosestran.co.uk',
        contactEmailHref: 'mailto:support@gosestran.co.uk',
        baseUrlIcon: '/sestran.ico',
        docsPolicy: './src/views/pages/sestran',
        homePath: './src/views/sestran',
        navPath: './src/components/sestran',
        support: 'https://support.gosestran.co.uk/portal/en-gb/newticket ',
        androidAppLink: '',
        iOSAppLink: '',
        showBreadcrumbs: true,
        showUpdatesFooter: true,
        showNeedHelp: true,
        showPois: true,
        enableUserAccounts: true,
        enableMultipleJourneyTypeFilter: false,
        blockedTravelTypes: [],
    },

    kcc: {
        brand: 'kcc',
        footerPath: './src/components/kcc',
        scssVariables: './src/styles/whitelabel-variables/kcc',
        navbarLogo: 'kcc/logo-full.svg',
        title: 'KCC Bus Platform',
        shortTitle: 'KCC',
        contactEmail: 'support@kcc.gov.uk',
        contactEmailHref: 'mailto:support@kcc.gov.uk',
        baseUrlIcon: '/kcc.ico',
        docsPolicy: './src/views/pages/kcc',
        homePath: './src/views/kcc',
        navPath: './src/components/kcc',
        support: 'https://support.kcc.gov.uk/portal/en-gb/newticket ',
        androidAppLink: '',
        iOSAppLink: '',
        showBreadcrumbs: false,
        showUpdatesFooter: false,
        showNeedHelp: false,
        showPois: false,
        enableUserAccounts: false,
        enableMultipleJourneyTypeFilter: true,
        blockedTravelTypes: ['taxi', 'own car', 'cycle'],
    },
}

module.exports = whitelabelConfig
